
import DirectInbox from "../../../assets/filled/DirectInbox.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DirectInboxIcon({ className, dataTestid = "DirectInboxIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DirectInbox data-testid={dataTestid} className={classes} {...rest} />
  );
}
